import { useMemo } from "react";

/**
 * @param {Array} memberAccnts        - data gốc từ DB (có id)
 * @param {Array} localMemberAccnts   - data đang chỉnh sửa
 */
export function useMemberDiffOptimized(
  memberAccnts = [],
  localMemberAccnts = []
) {
  return useMemo(() => {
    const stateMap = new Map();

    // ==== Build membersMap & idSet ====
    const membersSet = new Set(memberAccnts);
    
    const editIdSet = new Set();

    // ==== Added + Edited ====
    for (const accnt of localMemberAccnts) {
      if (!membersSet.has(accnt)) {
        stateMap.set(accnt, "new");
        continue;
      }

      editIdSet.add(accnt);
    }

    // ==== Deleted ====
    for (const accnt of memberAccnts) {
      if (!editIdSet.has(accnt)) {
        stateMap.set(accnt, "deleted");
      }
    }

    // ==== Output collections ====
    const added = [];
    const edited = [];
    const deleted = [];

    stateMap.forEach((state, id) => {
      if (state === "new") added.push(id);
      else if (state === "edited") edited.push(id);
      else if (state === "deleted") deleted.push(id);
    });

    console.log({stateMap})

    return {
      stateMap,
      added,
      edited,
      deleted,
      hasChanges: stateMap.size > 0,
    };
  }, [memberAccnts, localMemberAccnts]);
}
function useMemberDiffOptimized_old(
  members = [],
  localMembers = [],
  fields = ["name", "email", "birth", "gender"]
) {
  return useMemo(() => {
    const stateMap = new Map();

    // ==== Build membersMap & idSet ====
    const membersMap = new Map();
    const memberIdSet = new Set();

    for (const m of members) {
      membersMap.set(m.id, m);
      memberIdSet.add(m.id);
    }

    const localIdSet = new Set();

    // ==== Added + Edited ====
    for (const u of localMembers) {
      const id = u.id ?? u._tmpId;
      if (!id) continue;

      if (!u.id || !membersMap.has(u.id)) {
        stateMap.set(id, "new");
        continue;
      }

      localIdSet.add(u.id);

      const original = membersMap.get(u.id);
      let changed = false;

      for (const f of fields) {
        if (u[f] !== original[f]) {
          changed = true;
          break;
        }
      }

      if (changed) {
        stateMap.set(u.id, "edited");
      }
    }

    // ==== Deleted ====
    for (const m of members) {
      if (!localIdSet.has(m.id)) {
        stateMap.set(m.id, "deleted");
      }
    }

    // ==== Output collections ====
    const added = [];
    const edited = [];
    const deleted = [];

    stateMap.forEach((state, id) => {
      if (state === "new") added.push(id);
      else if (state === "edited") edited.push(id);
      else if (state === "deleted") deleted.push(id);
    });

    
    console.log({stateMap})

    return {
      stateMap,
      added,
      edited,
      deleted,
      hasChanges: stateMap.size > 0,
    };
  }, [members, localMembers, fields.join("|")]);
}